var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-comp"},[_c('el-button',{staticClass:"button-name",attrs:{"type":"danger","disabled":""}},[_vm._v(_vm._s(_vm.option.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }